<template>
  <div class="common-poup register-box">
    <h1 class="poup-title">石头网 · 注册</h1>
    <div class="form-wrapper-new form1 register-detail-box">
      <div class="form-box user-box form-item form1">
        <span class="form-item">
          <input ref="telBox" type="text" name="user" id="user" placeholder="请输入手机号" data-validate="mobile"
            v-model.trim="mobileNumber"
            autocomplete="off"
            @keyup.enter="register"
            @change="resetFlowId"
          >
				<div class="error-msg-box"></div>
        </span>
      </div>
	  <div class="form-box user-box form-item form1">
        <span class="form-item">
          <div id="captcha"></div>
          <input type="text" name="imgcode" id="imgcode" placeholder="请输入图形验证码" data-validate="imgcode" v-model.trim="captchaCode" autocomplete="off" @keyup.enter="register" maxlength="4" />
		  <div class="error-msg-box"></div>
          <img class="captcha" :src="'data:image/png;base64,'+captchaUrl" alt="" @click="refreshCaptcha">
        </span>
      </div>
<!--        <div id="captcha"></div>-->
      <div class="form-box code-box form-item">
        <input
          type="text"
          name="code"
          id="code"
					maxlength="6"
          placeholder="请输入手机验证码"
          data-validate="code"
          v-model.trim="smsCode"
          autocomplete="off"
          @keyup.enter="register"
        >
				<div class="error-msg-box"></div>
        <button class="code-msg-box" :disabled="disabled" @click="getSmsCode">{{smsText}}</button>
      </div>
      <div class="form-box password-box form-item">
        <input
          type="password"
          name="password"
          id="password"
          maxlength="20"
          data-validate="password"
          v-model.trim="password"
          placeholder="请输入6-20位数字字母组合"
          @keyup.enter="register"
        >
				<div class="error-msg-box"></div>
      </div>
      <div class="form-box password-again-box form-item">
        <input
          type="password"
          name="passwordAgain"
          id="passwordAgain"
          data-validate="password"
          v-model.trim="passwordAgain"
          placeholder="请再次输入6-20位数字字母组合"
          @keyup.enter="register"
        >
				<div class="error-msg-box password-error"></div>
      </div>
      <div class="check-box">
        <div class="remenber-box">
          <input
            type="checkbox"
            name="remenmber"
            id="remenmber"
            v-model="checked"
          >
          <label for="remenmber">我已阅读并同意</label>
          <span @click="open">《用户协议》</span>
        </div>
				<div class="check-error error-msg-box"></div>
      </div>
      <button class="login-btn" @click="register" :disabled="forbidden">完成注册</button>
    </div>
			<div class="bottom-btn">
				<span @click="$emit('poupwhich','loginPoup');">登录</span>
			</div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
		clearform:{
			type:Boolean
		}
	},
   data(){
    	return{
			mobileNumber:null,
			captchaUrl:'', //图形验证码图片
			captchaCode:'', //图形验证码
			captchaFlowId:'',
            smsCode:null,
            // nvc:'',
            password:null,
            passwordAgain:null,
            smsText:'获取验证码',
            seconds:60,
            timer:null,
            disabled:false,
            checked:false,
            flowId:'',
            forbidden:false
        };
    },
		components:{},
		watch:{
			clearform:function(v,n){
				if (v!=n) {
					this.mobileNumber=null;
					this.smsCode=null;
					this.password=null;
					this.passwordAgain=null;
					this.smsText="获取验证码";
					this.seconds=60;
					this.checked=false;
					this.disabled=false;
					this.forbidden=false;
					this.flowId='';
					clearInterval(this.timer);
					if (	$('div.error-msg-box').hasClass('error-msg-show')) {
						$('div.error-msg-box').removeClass('error-msg-show');
					}
				}
			}
		},
    created:function(){},
    mounted:function(){
		this.getCaptcha();
	},
    methods:{
		getCaptcha:function(){
            var _this = this;
			var opts = {
				isLoading: true,
				loadingDom: '',
				success: function(result) {
					_this.disabled=false;
					_this.captchaUrl=result.content.captcha;
					_this.captchaFlowId=result.content.flowId;
				},
				error:function(result){
					_this.disabled=true;
					_this.captchaFlowId='';
					_this.captchaUrl='';
				}
			};
			_this.getAjaxCommon(accountBaseUrl+'/account/captcha','get','',opts);
		},
		refreshCaptcha:function(){
            this.getCaptcha();
		},
    	getSmsCode:function(){
    		var _this = this;
			var data={
				mobileNumber:_this.mobileNumber,
				captcha:_this.captchaCode,
				flowId:_this.captchaFlowId,
                // nvc: getNVCVal()
			};
			var opts = {
				isLoading: true,
				loadingDom: '',
				success: function(result) {
                     //注册成功
                     // nvcReset();
					_this.flowId=result.content.flowId;
				},
				failSendSms:function(){
					_this.smsCode=null;
					_this.seconds=60;
					_this.smsText = '获取验证码';
					clearInterval(_this.timer);
					_this.disabled = false;
				},
                // failNVC: function(result){
                //     _this.smsCode=null;
                //     _this.seconds=60;
                //     _this.smsText = '获取验证码';
                //     clearInterval(_this.timer);
                //     _this.disabled = false;
                //     if(result.status==400){
                //         //唤醒滑动验证
                //         getNC().then(function(){
                //             _nvc_nc.upLang('cn', {
                //                 _startTEXT: "请按住滑块，拖动到最右边",
                //                 _yesTEXT: "验证通过",
                //                 _error300: "哎呀，出错了，点击<a href=\"javascript:__nc.reset()\">刷新</a>再来一次",
                //                 _errorNetwork: "网络不给力，请<a href=\"javascript:__nc.reset()\">点击刷新</a>",
                //             })
                //             _nvc_nc.reset()
                //         })
                //     }else if(result.status==600){
                //         //唤醒刮刮卡
                //         getSC().then(function(){})
                //     }else if(result.status==700){
                //         //唤醒问答验证码
                //         getLC();
                //     }else if(result.status==800||result.status==900){
                //         //直接拦截
                //         nvcReset();
                //         _this.smsText = '验证失败';
                //     }
                // },
				error:function(result){
					_this.mobileNumber=null;
					_this.smsCode=null;
					_this.flowId='000';
					_this.captchaFlowId='';
					_this.captchaCode='';
					_this.getCaptcha();
					// _this.$message({
					// 	showClose: true,
					// 	message: result.message,
					// 	type: 'warning'
					// });
					_this.$layer.msg(result.message);
					if (_this.timer) {
						clearInterval(_this.timer)
	                    _this.disabled = false;
	                    _this.seconds = 60;
	                    _this.smsText = '获取验证码';
					}
				}
			};
			var isValidate=doValidate('div.user-box');
			if (isValidate) {
				_this.disabled=true;
				_this.smsText=_this.seconds+'秒后重新获取';
				_this.$options.methods.setIntervalSecs(_this);
				_this.getAjaxCommon(accountBaseUrl+'/account/sendCode','post',data,opts);
			}else{
				this.$refs.telBox.focus();
			}
    	},
    	setIntervalSecs:function($this){
    		var _this = $this;
    		_this.timer = setInterval(function () {
                _this.seconds--;
                _this.smsText = _this.seconds + '秒后重新获取';
                if (_this.seconds < 0) {
                	clearInterval(_this.timer)
                    _this.disabled = false;
                    _this.seconds = 60;
                    _this.smsText = '获取验证码';
                }
            }, 1000);
    	},
    // 	checkSmsCode:function($this){
		// 	var _this = $this?$this:this;
		// 	var data={
		// 		flowId :_this.flowId ,
		// 		smsCode :_this.smsCode
		// 	};
		// 	var opts = {
		// 		isLoading: true,
		// 		loadingDom: '',
		// 		success: function(result) {
		// 			_this.$options.methods.loginRequest(_this);
		// 		},
		// 		error:function(result){
		// 			_this.forbidden=false;
		// 			_this.smsCode=null;
		// 			_this.$message({
		// 				showClose: true,
		// 				message: result.message,
		// 				type: 'warning'
		// 			});
		// 		}
		// 	};
		// 	_this.getAjaxCommon(accountBaseUrl+'/account/checkSmsCode','post',data,opts);
		// },
    	loginRequest:function($this){
			var _this = $this?$this:this;
			var data={
				mobileNumber:_this.mobileNumber,
				password:_this.password,
				flowId:_this.flowId,
				smsCode:_this.smsCode
			};
			var opts = {
				isLoading: true,
				loadingDom: '',
				success: function(result) {
					_this.$emit('poupwhich','noticePoup');
				},
				error:function(result){
				  _this.mobileNumber=null;
					_this.smsCode=null;
					_this.flowId='000';
					_this.password =null;
					_this.passwordAgain =null;
					_this.forbidden=false;
					_this.captchaFlowId='';
					_this.captchaCode='';
					_this.checked=false;
					_this.getCaptcha();
					// _this.$message({
					// 	showClose: true,
					// 	message: result.message,
					// 	type: 'warning'
					// });
					_this.$layer.msg(result.message);
					if (_this.timer) {
						clearInterval(_this.timer)
	            _this.disabled = false;
	            _this.seconds = 60;
	            _this.smsText = '获取验证码';
					}
				}
			};
			_this.getAjaxCommon(accountBaseUrl+'/account/register','post',data,opts);
		},
		register:function(){
			var isValidate=doValidate('div.form-wrapper-new');
			if (isValidate) {
				if (!this.checked) {
					$('div.error-msg-box.check-error').addClass('error-msg-show').html('请阅读并同意《用户协议》！');
					return false;
				}else{
					$('div.error-msg-box.check-error').removeClass('error-msg-show').html('');
				}
				if (!(this.password===this.passwordAgain)) {
					$('div.error-msg-box.password-error').addClass('error-msg-show').html('两次密码不一致！');
					return false;
				}else{
					$('div.error-msg-box.password-error').removeClass('error-msg-show').html('');
				}
			}

			if (isValidate&&this.checked&&(this.password===this.passwordAgain)) {
				this.forbidden=true;
				// this.$options.methods.checkSmsCode(this);
				this.$options.methods.loginRequest(this);
			}
		},
		resetFlowId:function(){
        this.flowId='000';
		},
		open:function() {
			var h = this.$createElement;
			this.$msgbox({
				title: '',
				customClass: 'myProup',
				closeOnClickModal:false,
				closeOnPressEscape:false,
				message: h('div', {
					style: 'text-align:left;'
				}, [
					h('p', {
						style: 'margin-top:40px;margin-bottom:41px;font-size:18px;font-weight:bold; text-align:center;'
					}, '用户协议'),
					h('div',{
						style: 'height:531px;overflow-y: auto; padding:0 35px;'
					},[
						h('p', {
							style: ''
						}, '您只有接受以下所有服务条款，才能继续申请：'),
						h('p', {
							style: ''
						}, '1、服务条款的确认和接纳'),
						h('p', {
							style: 'text-indent:28px;'
						}, '石头网服务(以下简称石头网的所有权和运作权归麟龙科技股份有限公司(以下简称麟龙公司)所有，包括但不限于行情软件、委托交易系统、网站、手机短信服务等。所提供的服务必须按照麟龙公司章程，服务条款和操作规则严格执行。用户完成注册程序即表示用户与麟龙公司达成协议并接受所有的服务条款。'),
						h('p', {
							style: ''
						}, '2、服务简介'),
						h('p', {
							style: 'text-indent:28px;'
						}, '麟龙公司运用自己的服务系统通过互联网络为用户提供各项服务。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '用户必须：支付个人上网和与此服务有关的费用。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '麟龙公司运用自己的服务系统通过互联网络为用户提供各项服务。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '考虑到石头网产品服务的重要性，用户同意：'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(1)提供及时、详尽及准确的个人资料。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(2)不断更新注册资料，符合及时、详尽准确的要求。所有原始键入的资料将引用为注册资料。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '用户主动填写的注册信息为麟龙公司及其子公司所有，麟龙公司及其子公司可据此为用户提供服务。另外，用户可授权麟龙公司及其子公司向其他公司透露其注册资料，否则麟龙公司及其子公司不能公开用户的姓名、住址、电子邮箱、帐号。'),
						h('p', {
							style: ''
						}, '除非：'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(1)用户要求麟龙公司通过电子邮件服务透露这些信息。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(2)相应的法律、法规要求及程序服务需要麟龙公司提供用户的个人资料。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '如果用户提供的资料不准确，不真实，不合法有效，麟龙公司保留结束用户使用石头网各项服务的权利。'),
						h('p', {
							style: ''
						}, '3、服务条款的修改'),
						h('p', {
							style: 'text-indent:28px;'
						}, '麟龙公司会在必要时修改服务条款，服务条款一旦发生变动，麟龙公司将会在用户进入下一步使用前的页面提示修改内容。如果您同意改动，则再一次激活"我同意"按钮。如果您不接受，则及时取消您的用户使用服务资格。'),
						h('p', {
							style: ''
						}, '用户要继续使用石头网各项服务需要两方面的确认：'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(1)首先确认服务条款及其变动。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(2)同意接受所有的服务条款限制。'),
						h('p', {
							style: ''
						}, '4、服务修订'),
						h('p', {
							style: 'text-indent:28px;'
						}, '麟龙公司保留随时修改或中断服务而不需通知用户的权利。用户接受麟龙公司行使修改或中断服务的权利，麟龙公司不需对用户或第三方负责。'),
						h('p', {
							style: ''
						}, '5、用户隐私制度'),
						h('p', {
							style: 'text-indent:28px;'
						}, '尊重用户个人隐私是麟龙公司的一项基本政策。所以，作为对以上第二点个人注册资料分析的补充，麟龙公司一定不会公开、编辑或透露用户的注册资料及保存在石头网各项服务中的非公开内容，除非麟龙公司在诚信的基础上认为透露这些信息在以下几种情况是必要的：'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(1)遵守有关法律规定，包括在国家有关机关查询时，提供用户在石头网的网页上发布的信息内容及其发布时间、互联网地址或者域名。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(2)遵从麟龙公司产品服务程序。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(3)保持维护麟龙公司的商标所有权。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(4)在紧急情况下竭力维护用户个人和社会大众的隐私安全。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(5)根据第10条的规定或者麟龙公司认为必要的其他情况下。用户在此授权麟龙公司可以向其电子邮箱发送商业信息。用户在享用石头网各项服务的同时，同意接收石头网发出的各类信息。'),
						h('p', {
							style: ''
						}, '6、用户的帐号、密码和安全性'),
						h('p', {
							style: 'text-indent:28px;'
						}, '您一旦注册成功成为用户，您将得到一个密码和帐号。如果您未保管好自己的帐号和密码而对您、麟龙公司或第三方造成的损害，您将负全部责任。另外，每个用户都要对其帐户中的所有活动和事件负全责。您可随时改变您的密码，也可以结束旧的帐户重开一个新帐户。用户同意若发现任何非法使用用户帐号或安全漏洞的情况，立即通告麟龙公司。'),
						h('p', {
							style: ''
						}, '7、拒绝提供担保'),
						h('p', {
							style: 'text-indent:28px;'
						}, '用户明确同意服务的使用由用户个人承担风险。麟龙公司明确表示不提供任何类型的担保，不论是明确的或隐含的，但是对商业性的隐含担保，特定目的和不违反规定的适当担保除外。麟龙公司不担保服务一定能满足用户的要求，也不担保服务不会受中断，对服务的及时性、安全性、出错发生都不作担保。麟龙公司拒绝提供任何担保，包括信息能否准确、及时、顺利地传送。用户理解并接受下载或通过麟龙公司产品服务取得的任何信息资料取决于用户自己，并由其承担系统受损或资料丢失的所有风险和责任。麟龙公司对在石头网上得到的任何商品购物服务或交易进程，都不作担保。用户不会从麟龙公司收到口头或书面的意见或信息，麟龙公司也不会在这里作明确担保。'),
							h('p', {
							style: ''
						}, '8、有限责任'),
						h('p', {
							style: 'text-indent:28px;'
						}, '麟龙公司对直接、间接、偶然、特殊及继起的损害不负责任，这些损害来自：不正当使用产品服务，在网上购买商品或类似服务，在网上进行交易，非法使用服务或用户传送的信息有所变动。这些损害会导致麟龙公司形象受损，所以麟龙公司早已提出这种损害的可能性。'),
						h('p', {
							style: ''
						}, '9、石头网信息的储存及限制'),
						h('p', {
							style: 'text-indent:28px;'
						}, '麟龙公司不对用户所发布信息的删除或储存失败负责。麟龙公司保留判定用户的行为是否符合石头网服务条款的要求和精神的权利，如果用户违背了服务条款的规定，则中断其石头网服务的帐号。石头网所有的文章版权归原文作者和麟龙公司共同所有，任何人需要转载石头网的文章，必须征得原文作者和麟龙公司授权。'),
						h('p', {
							style: ''
						}, '10、用户管理'),
						h('p', {
							style: 'text-indent:28px;'
						}, '用户单独承担发布内容的责任。用户对服务的使用是根据所有适用于服务的地方法律、国家法律和国际法律标准的。用户承诺：'),
							h('p', {
							style: 'text-indent:28px;'
						}, '(1)在石头网的网页上发布信息或者利用石头网的服务时必须符合中国有关法规(部分法规请见附录)，不得在石头网的网页上或者利用石头网的服务制作、复制、发布、传播以下信息：'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(a)反对宪法所确定的基本原则的；'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(b) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；'),
						h('p', {
							style: 'text-indent:28px;'
						}, ' (c) 损害国家荣誉和利益的；'),
						h('p', {
							style: 'text-indent:28px;'
						}, ' (d) 煽动民族仇恨、民族歧视，破坏民族团结的；'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(e) 破坏国家宗教政策，宣扬邪教和封建迷信的；'),
						h('p', {
							style: 'text-indent:28px;'
						}, ' (f) 散布谣言，扰乱社会秩序，破坏社会稳定的；'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(g) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；'),
						h('p', {
							style: 'text-indent:28px;'
						}, ' (h) 侮辱或者诽谤他人，侵害他人合法权益的；'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(i) 含有法律、行政法规禁止的其他内容的。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(2)在石头网的网页上发布信息或者利用石头网的服务时还必须符合其他有关国家和地区的法律规定以及国际法的有关规定。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(3)不利用石头网的服务从事以下活动：'),
							h('p', {
							style: 'text-indent:28px;'
						}, '(a) 未经允许，进入计算机信息网络或者使用计算机信息网络资源的；'),
							h('p', {
							style: 'text-indent:28px;'
						}, ' (b) 未经允许，对计算机信息网络功能进行删除、修改或者增加的；'),
							h('p', {
							style: 'text-indent:28px;'
						}, ' (c) 未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；'),
							h('p', {
							style: 'text-indent:28px;'
						}, '(d) 故意制作、传播计算机病毒等破坏性程序的；'),
							h('p', {
							style: 'text-indent:28px;'
						}, ' (e) 其他危害计算机信息网络安全的行为。'),
					  h('p', {
							style: 'text-indent:28px;'
						}, '(4)不以任何方式干扰石头网的服务。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(5)遵守石头网的所有其他规定和程序。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '用户需对自己在使用石头网服务过程中的行为承担法律责任。用户理解，如果石头网发现其网站传输的信息明显属于上段第(1)条所列内容之一，依据中国法律，麟龙公司有义务立即停止传输，保存有关记录，向国家有关机关报告，并且删除含有该内容的地址、目录或关闭服务器。'),
					  h('p', {
							style: 'text-indent:28px;'
						}, '用户使用石头网电子公告服务，包括电子布告牌、电子白板、电子论坛、网络聊天室和留言板等以交互形式为上网用户提供信息发布条件的行为，也须遵守本条的规定以及石头网将专门发布的电子公告服务规则，上段中描述的法律后果和法律责任同样适用于电子公告服务的用户'),
						h('p', {
							style: 'text-indent:28px;'
						}, '若用户的行为不符合以上提到的服务条款，麟龙公司将作出独立判断立即取消用户服务帐号。'),
						h('p', {
							style: ''
						}, '11、保障'),
						h('p', {
							style: 'text-indent:28px;'
						}, '用户同意保障和维护麟龙公司全体成员的利益，负责支付由用户使用超出服务范围引起的律师费用，违反服务条款的损害补偿费用，其它人使用用户的电脑、帐号和其它知识产权的追索费。'),
						h('p', {
							style: ''
						}, '12、结束服务'),
						h('p', {
							style: 'text-indent:28px;'
						}, '用户或麟龙公司可随时根据实际情况中断服务。麟龙公司不需对任何个人或第三方负责而随时中断服务。用户若反对任何服务条款的建议或对后来的条款修改有异议，或对石头网的服务不满，用户只有以下的追索权：'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(1)不再使用石头网服务。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(2)结束用户使用石头网服务的资格。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '(3)通告麟龙公司停止该用户的服务。结束用户服务后，用户使用石头网服务的权利马上中止。从那时起，麟龙公司不再对用户承担任何义务。'),
						h('p', {
									style: ''
						}, '13、通告'),
						h('p', {
									style: 'text-indent:28px;'
						}, '所有发给用户的通告都可通过电子邮件或常规的信件传送。麟龙公司会通过邮件服务发报消息给用户，告诉他们服务条款的修改、服务变更、或其它重要事情。'),
			      h('p', {
									style: ''
						}, '14、参与广告策划'),
						h('p', {
							style: 'text-indent:28px;'
						}, '在麟龙公司许可下用户可在他们发表的信息中加入宣传资料或参与广告策划，在石头网各项免费服务上展示他们的产品。任何这类促销方法，包括运输货物、付款、服务、商业条件、担保及与广告有关的描述都只是在相应的用户和广告销售商之间发生。麟龙公司不承担任何责任，麟龙公司没有义务为这类广告销售负任何一部分的责任。'),
						h('p', {
									style: ''
						}, '15、内容的所有权'),
						h('p', {
							style: 'text-indent:28px;'
						}, '内容的定义包括：文字、软件、声音、相片、录象、图表；在广告中的全部内容；石头网服务为用户提供的商业信息。所有这些内容均受版权、商标、标签和其它财产所有权法律的保护。所以，用户只能在麟龙公司和广告商授权下才能使用这些内容，而不能擅自复制、再造这些内容、或创造与内容有关的派生产品。'),
						h('p', {
									style: ''
						}, '16、法律'),
						h('p', {
							style: 'text-indent:28px;'
						}, '用户和麟龙公司一致同意有关本协议以及使用石头网的服务产生的争议交由仲裁解决，但是麟龙公司有权选择采取诉讼方式，并有权选择受理该诉讼的有管辖权的法院。若有任何服务条款与法律相抵触，那这些条款将按尽可能接近的方法重新解析，而其它条款则保持对用户产生法律效力和影响。'),
						h('p', {
									style: ''
						}, '17、石头网所含服务的信息储存及安全'),
						h('p', {
							style: 'text-indent:28px;'
						}, '麟龙公司对石头网服务将尽力维护其安全性及方便性，但对服务中出现信息删除或储存失败不承担任何负责。另外我们保留判定用户的行为是否符合石头网服务条款的要求的权利，如果用户违背了服务条款的规定，将会中断其服务的帐号。'),
						h('p', {
							style: 'text-indent:28px;'
						}, '附：中华人民共和国电信条例,互联网信息服务管理办法,互联网电子公告服务管理规定,中华人民共和国计算机信息网络国际联网管理暂行规定,中华人民共和国计算机信息网络国际联网管理暂行规定实施办法,中华人民共和国计算机信息系统安全保护条例,计算机信息网络国际联网安全保护管理办法。'),
			   ])
				]),
				showCancelButton: false,
				showConfirmButton:false,
				callback: function() { //不写此回调函数会报错
				}
			});
			}
    }
};
</script>
<style lang="scss">
@import "~scss/mixin";
	div.myProup {
    width: 650px;
    padding-bottom: 45px;
		color: $login-color;
		@include borderradius(0);
		border: 7px solid rgba(255, 255, 255, .3);
		background-color: $color-title;
		background-clip:padding-box;
		-webkit-background-clip: padding-box;
		-moz-background-clip: padding-box;
    div.el-message-box__header {
        padding: 0;
        button.el-message-box__headerbtn {
           top: 15px;
					 right: 15px;
					 z-index: 100;
					 .el-message-box__close {
								color: #c2c2c2;
						    font-size: 26px;
						}
            &:focus,
            &:hover {
                .el-message-box__close {
                    color: $hover-color;
                }
            }
        }
    }
}
</style>
<style lang="scss"  scoped="scoped">
@import "~scss/poup";
@import "~scss/mixin";
* {
		margin: 0;
		padding: 0;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
		-ms-tap-highlight-color: rgba(0, 0, 0, 0);
		tap-highlight-color: rgba(0, 0, 0, 0);
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		-ms-box-sizing: border-box;
		box-sizing: border-box;
		-ms-text-size-adjust: 100%;
		-webkit-text-size-adjust: 100%;
}
div.register-box{
    width:446px;
    height:564px;
    h1.poup-title{
        background:url(~images/register_title.png) no-repeat 10px 10px;
        text-indent:-9999px;
        margin-bottom:42px;
        height: 40px;
		}
		div.form-wrapper-new{
			&.register-detail-box{
				margin-top: -40px;
			}
			div.code-box{
				>input{
					padding-right:140px;
				}
			}
		  div.check-error{
				font-size: 12px;
        color: $hover-color;
				position: absolute;
				top: -19px;
				left: 0;
			}
		}

}

</style>



// WEBPACK FOOTER //
// src/components/registerPoup.vue